var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('hero'),_c('intro'),_c('story-slider',{staticStyle:{"margin-top":"-13.5rem"}}),_c('ow-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }